module.exports = __webpack_public_path__ + "static/img/A84.7e2a5bd0.jpg";